import React, { useEffect, useRef, useState } from "react";
import "../../css_files/Ticket/Step3Ticket.css";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import getCookie from "../../api";
import html2canvas from "html2canvas";
import { ToWords } from "to-words";
import jsPDF from "jspdf";
import { toast, ToastContainer } from "react-toastify";
import axiosInstance from "../../api";

function Step3Ticket({ quotationId, enquiryId, setCatchStep }) {
  setCatchStep(useLocation().pathname.split("/")[4].trim());

  const [enquiryData, setEnquiryData] = useState();
  const [quotationData, setQuotationData] = useState();
  const [quotationItemsData, setQuotationItemsData] = useState([]);
  const [partsItemData, setPartsItemData] = useState([]);
  const [procedureData, setProcedureData] = useState([]);
  const [commercialTermsData, setCommercialTermsData] = useState([]);
  const nav = useNavigate();
  const quotationref = useRef();
  const [emailloading, setEmailloading] = useState(false);
  const toWords = new ToWords({
    localeCode: "en-IN",
  });

  useEffect(() => {
    axiosInstance
      .get(
        `${
          process.env.REACT_APP_API_URL
        }/api/v1/NewEnquiry/GetEnquiryById?seriesId=${encodeURIComponent(
          enquiryId
        )}`
      )
      .then((res) => {
        setEnquiryData(res.data);
      })
      .catch(console.log);
  }, [enquiryId]);

  useEffect(() => {
    axiosInstance
      .get(
        `${process.env.REACT_APP_API_URL}/api/v1/Quotation/${encodeURIComponent(
          quotationId
        )}`
      )
      .then((res) => {
        setQuotationData(res.data);
        if (enquiryData?.enquiryType === "Parts") {
          axiosInstance
            .get(
              `${process.env.REACT_APP_API_URL}/api/PartItems/${res.data.id}`
            )
            .then((resp) => {
              setPartsItemData(resp.data);
            })
            .catch(console.log);
        } else {
          axiosInstance
            .get(
              `${process.env.REACT_APP_API_URL}/api/QuotationItems/${res.data.id}`
            )
            .then((resp) => {
              setQuotationItemsData(resp.data);
            })
            .catch(console.log);
          axiosInstance
            .get(
              `${process.env.REACT_APP_API_URL}/api/ProcedureDetails/${res.data.id}`
            )
            .then((resp) => {
              setProcedureData(resp.data);
            })
            .catch(console.log);
        }
        axiosInstance
          .get(
            `${process.env.REACT_APP_API_URL}/api/CommercialTerms/${res.data.id}`
          )
          .then((resp) => {
            setCommercialTermsData(resp.data);
          })
          .catch(console.log);
      })
      .catch(console.log);
  }, [quotationId, enquiryData?.enquiryType]);

  return (
    <section className="step3-ticket" ref={quotationref}>
      <blockquote style={{ borderBottom: "1px solid gray" }}>
        <h1>{enquiryData?.enquiryType} Quotation/Performa invoice</h1>
      </blockquote>
      <blockquote id="printandEmailQuotation">
        {/*emailloading ? (
          <i class="fa-solid fa-arrows-spin fa-spin"></i>
        ) : (
          <i
            className="fa-solid fa-envelope"
            onClick={() => {
              setEmailloading(true);
              html2canvas(quotationref.current).then((canvas) => {
                axiosInstance
                  .post(
                    `${process.env.REACT_APP_API_URL}/api/SendEmail/SendMail`,
                    {
                      To: enquiryData?.customerEmail,
                      Base64String: canvas.toDataURL("image/png"),
                    }
                  )
                  .then((res) => {
                    toast.success(res.data, {
                      position: "bottom-center",
                      theme: "dark",
                    });
                    setEmailloading(false);
                  })
                  .catch((err) => {
                    toast.error("Failed to Send Mail", {
                      position: "bottom-center",
                      theme: "dark",
                    });
                    setEmailloading(false);
                  });
              });
            }}
          ></i>
        )*/}
        <i className="fa-solid fa-print" onClick={() => window.print()}></i>
        <i
          className="fa-solid fa-download"
          onClick={() => {
            const continueToOrder = document.getElementById(
              "continueToOrderFromQuotation"
            );
            const icons = document.getElementById("printandEmailQuotation");
            continueToOrder.style.display = "none";
            icons.style.display = "none";
            html2canvas(quotationref.current).then((canvas) => {
              const imgData = canvas.toDataURL("image/png");
              const pdf = new jsPDF("p", "mm", "a4");

              const pdfWidth = pdf.internal.pageSize.getWidth();
              const pdfHeight = pdf.internal.pageSize.getHeight();

              const bottomPadding = 10;
              const usableHeight = pdfHeight - bottomPadding;

              const imgWidth = pdfWidth;
              const imgHeight = (canvas.height * imgWidth) / canvas.width;

              let heightLeft = imgHeight;
              let position = 0;

              pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
              heightLeft -= usableHeight;

              while (heightLeft > 0) {
                position -= usableHeight;
                pdf.addPage();
                pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
                heightLeft -= usableHeight;
              }

              pdf.save(
                "Quotation_" +
                  enquiryData.seriesID
                    .replace("-", "")
                    .replace("SE", "")
                    .replace("PE", "")
              );
              continueToOrder.style.display = "block";
              icons.style.display = "flex";
            });
          }}
        ></i>
      </blockquote>
      <div>
        <aside>
          <img src="/images/Image 1000.png" />

          {/*
          <blockquote>
            <p>
              <strong>Quotation Id: </strong>
              {quotationData && quotationData.seriesId}
            </p>
            <p>
              <strong>Linked to Ticket Id: </strong>
              {ticketId}
            </p>

            <p>
              <strong>Quotation Date </strong>
              {new Date().toLocaleDateString()}
            </p>
          </blockquote>*/}
        </aside>
        <aside>
          {enquiryData && (
            <blockquote>
              <h2>M/s</h2>
              <p></p>
              <p>{enquiryData.customer.orgName}</p>
              <p></p>
              <p style={{ gridColumn: enquiryData.isAddressSame && "span 2" }}>
                <strong>
                  {enquiryData.isAddressSame
                    ? "Shipping / Billing Address: "
                    : "Shipping Address: "}
                </strong>
                {enquiryData.shipToAddress.officeName ||
                  enquiryData.shipToAddress.factoryName}
                , {enquiryData.shipToAddress.address1},{" "}
                {enquiryData.shipToAddress.address2},{" "}
                {enquiryData.shipToAddress?.cityObj?.name ||
                  enquiryData.shipToAddress?.cityName}
                ,{" "}
                {enquiryData.shipToAddress?.stateObj?.name ||
                  enquiryData.shipToAddress?.stateName}
                , {enquiryData.shipToAddress.country},{" "}
                {enquiryData.shipToAddress.pincode}
              </p>

              <p>
                {enquiryData.isAddressSame === false && (
                  <>
                    <strong>Billing Address: </strong>
                    {enquiryData.billToAddress.officeName ||
                      enquiryData.shipToAddress.factoryName}
                    , {enquiryData.billToAddress.address1},{" "}
                    {enquiryData.billToAddress.address2},{" "}
                    {enquiryData.billToAddress?.cityObj?.name ||
                      enquiryData.billToAddress?.cityName}
                    ,{" "}
                    {enquiryData.billToAddress?.stateObj?.name ||
                      enquiryData.billToAddress?.stateName}
                    , {enquiryData.billToAddress.country},{" "}
                    {enquiryData.billToAddress.pincode}
                  </>
                )}
              </p>

              <p style={{ gridColumn: "span 2" }}>
                <i class="fa-solid fa-address-book" title="Contact"></i>{" "}
                {enquiryData.contactCentre.salutation}{" "}
                {enquiryData.contactCentre.name}
                &nbsp; &nbsp; &nbsp;
                <i class="fa-solid fa-envelope" title="Email"></i>{" "}
                {enquiryData.contactCentre.email}
                &nbsp; &nbsp; &nbsp;
                <i class="fa-solid fa-phone" title="Phone Number"></i>{" "}
                {enquiryData.contactCentre.phoneNumber}
                &nbsp; &nbsp; &nbsp;
                <span>
                  <strong>GST Number: </strong>
                  {enquiryData.customer.gstNumber}
                </span>
              </p>
              <p>
                <strong>Quotation Id: </strong>
                {quotationId}
              </p>
              <p>
                <strong>Created On: </strong>
                {new Date(
                  quotationData?.updatedDate || quotationData?.createdDate
                ).toDateString()}
              </p>
              <p>
                <strong>Boiler Head & Series: </strong>
                {enquiryData?.customerBoiler?.boiler?.head + " "}
                {enquiryData?.customerBoiler?.boilerSeriess?.seriesCode}
              </p>
            </blockquote>
          )}
        </aside>
        <section>
          {enquiryData?.enquiryType === "Parts" ? (
            <table>
              <thead>
                <tr>
                  <th style={{ width: "2rem" }}>Sr.No.</th>
                  <th>Part Number</th>
                  <th>Part Name</th>
                  <th>HSN Code</th>
                  <th>Qty.</th>
                  <th>Price Per Part ({quotationData?.symbol})</th>
                  <th>Total Amount ({quotationData?.symbol})</th>
                </tr>
              </thead>
              {partsItemData && (
                <tbody>
                  {partsItemData.map((partItem, i) => (
                    <tr key={i}>
                      <td>
                        <center>{i + 1}</center>
                      </td>
                      <td>
                        <center>{partItem.partNumber}</center>
                      </td>
                      <td>
                        <center>{partItem.partName}</center>
                      </td>
                      <td>
                        <center>{partItem.hsnCode || ""}</center>
                      </td>
                      <td>
                        <center>{partItem.quantity}</center>
                      </td>
                      <td>
                        <center>{partItem.rate}</center>
                      </td>
                      <td>
                        <center>{Math.round(partItem.amount)}</center>
                      </td>
                    </tr>
                  ))}
                  <tr>
                    <td colSpan={6} style={{ textAlign: "right" }}>
                      SubTotal
                    </td>
                    <td>
                      <center>
                        <b>{Math.round(quotationData?.subTotal)}</b>
                      </center>
                    </td>
                  </tr>
                  {quotationData?.packingForwarding !== 0.0 && (
                    <tr>
                      <td colSpan={6} style={{ textAlign: "right" }}>
                        Packing & Forwarding
                      </td>
                      <td>
                        <center>
                          {Math.round(quotationData?.packingForwarding)}
                        </center>
                      </td>
                    </tr>
                  )}
                  {quotationData?.courierExp !== 0.0 && (
                    <tr>
                      <td colSpan={6} style={{ textAlign: "right" }}>
                        Transport/Courier Charges
                      </td>
                      <td>
                        <center>{Math.round(quotationData?.courierExp)}</center>
                      </td>
                    </tr>
                  )}

                  {quotationData?.discountPercentage !== 0 && (
                    <tr>
                      <td colSpan={6} style={{ textAlign: "right" }}>
                        Discount ({quotationData?.discountPercentage}%)
                      </td>
                      <td>
                        <center>
                          {Math.round(quotationData?.discountValue)}
                        </center>
                      </td>
                    </tr>
                  )}
                  {(quotationData?.packingForwarding !== 0.0 ||
                    quotationData?.courierExp !== 0.0 ||
                    quotationData?.discountPercentage !== 0) && (
                    <tr>
                      <td colSpan={6} style={{ textAlign: "right" }}>
                        Final Total
                      </td>
                      <td>
                        <center>
                          <b>{Math.round(quotationData?.finalTotal)}</b>
                        </center>
                      </td>
                    </tr>
                  )}
                  {quotationData?.gstPercentage !== 0 && (
                    <tr>
                      <td colSpan={6} style={{ textAlign: "right" }}>
                        GST ({quotationData?.gstPercentage}%)
                      </td>
                      <td>
                        <center>{Math.round(quotationData?.gstAmount)}</center>
                      </td>
                    </tr>
                  )}
                  <tr>
                    <td colSpan={6} style={{ textAlign: "right" }}>
                      Grand Total
                    </td>
                    <td>
                      <center>
                        <b>{Math.round(quotationData?.grandTotal)}</b>
                      </center>
                    </td>
                  </tr>
                </tbody>
              )}
            </table>
          ) : (
            <table>
              <thead>
                <tr>
                  <th style={{ width: "2rem" }}>Sr.No.</th>
                  <th>Item Description</th>
                  <th>Days</th>
                  <th>Rate ({quotationData?.symbol})</th>
                  <th>Amount ({quotationData?.symbol})</th>
                </tr>
              </thead>
              {quotationItemsData && (
                <tbody>
                  {quotationItemsData.map((quotationItem, i) => (
                    <tr key={i}>
                      <td>
                        <center>{i + 1}</center>
                      </td>
                      <td>
                        <center>{quotationItem.description}</center>
                      </td>
                      <td>
                        <center>{quotationItem.noOfDays}</center>
                      </td>
                      <td>
                        <center>{quotationItem.pricePerDay}</center>
                      </td>
                      <td>
                        <center>{Math.round(quotationItem.total)}</center>
                      </td>
                    </tr>
                  ))}
                  <tr>
                    <td colSpan={4} style={{ textAlign: "right" }}>
                      SubTotal
                    </td>
                    <td>
                      <center>
                        <b>{Math.round(quotationData?.subTotal)}</b>
                      </center>
                    </td>
                  </tr>

                  {quotationData?.discountPercentage !== 0 && (
                    <>
                      <tr>
                        <td colSpan={4} style={{ textAlign: "right" }}>
                          Discount ({quotationData?.discountPercentage}%)
                        </td>
                        <td>
                          <center>
                            {Math.round(quotationData?.discountValue)}
                          </center>
                        </td>
                      </tr>
                      <tr>
                        <td colSpan={4} style={{ textAlign: "right" }}>
                          Final Total
                        </td>
                        <td>
                          <center>
                            <b>{Math.round(quotationData?.finalTotal)}</b>
                          </center>
                        </td>
                      </tr>
                    </>
                  )}
                  {quotationData?.gstPercentage !== 0 && (
                    <tr>
                      <td colSpan={4} style={{ textAlign: "right" }}>
                        GST ({quotationData?.gstPercentage}%)
                      </td>
                      <td>
                        <center>{Math.round(quotationData?.gstAmount)}</center>
                      </td>
                    </tr>
                  )}
                  <tr>
                    <td colSpan={4} style={{ textAlign: "right" }}>
                      Grand Total
                    </td>
                    <td>
                      <center>
                        <b>{Math.round(quotationData?.grandTotal)}</b>
                      </center>
                    </td>
                  </tr>
                </tbody>
              )}
            </table>
          )}

          <p style={{ textAlign: "right", marginTop: "3px" }}>
            <strong>Amount In Words: </strong>
            {toWords.convert(Math.round(quotationData?.grandTotal || 0))}{" "}
            {quotationData?.symbol === "INR" ? "Only" : quotationData?.symbol}
          </p>
        </section>

        <div>
          {enquiryData?.enquiryType === "Service" && (
            <table>
              <thead>
                <tr>
                  <th>Sr.No.</th>
                  <th>Terms</th>
                </tr>
              </thead>
              <tbody>
                {procedureData.map((procedure, i) => (
                  <tr>
                    <td>
                      <center>{i + 1}</center>
                    </td>
                    <td>{procedure.description}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>

        <div>
          <table>
            <thead>
              <tr>
                <th style={{ width: "2rem" }}>Sr.No.</th>
                <th colSpan={2}>Commercial Terms</th>
              </tr>
            </thead>
            <tbody>
              {commercialTermsData.map((term, i) => (
                <tr>
                  <td>
                    <center>{i + 1}</center>
                  </td>
                  <td>{term.title}</td>
                  <td>{term.description}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <p style={{ fontSize: "1.2rem" }}>{quotationData?.declaration}</p>
        </div>

        <aside>
          <blockquote>
            <dl>
              <dt>Account Name</dt>
              <dd>Ross Boilers</dd>
              <dt>Bank Name</dt>
              {quotationData?.symbol == "INR" ? (
                <dd>ICICI Bank</dd>
              ) : (
                <dd>Kotak Mahindra Bank Ltd , India </dd>
              )}
              {quotationData?.symbol == "INR" && (
                <>
                  <dt>Branch</dt>
                  <dd>Kondhwa Pune 411048</dd>
                </>
              )}
              <dt>Bank Account Number</dt>
              {quotationData?.symbol == "INR" ? (
                <dd>007405004847</dd>
              ) : (
                <dd>7211427534 </dd>
              )}
              {quotationData?.symbol == "INR" ? (
                <dt>IFSC Code</dt>
              ) : (
                <dt>SWIFT Code</dt>
              )}
              {quotationData?.symbol == "INR" ? (
                <dd>ICIC0000074</dd>
              ) : (
                <dd>KKBKINBB</dd>
              )}
              {quotationData?.symbol != "INR" && (
                <>
                  <dt>Intermediary / Correspondence Bank & Address</dt>
                  <dd>Bank of America NA New York </dd>
                  <dt>Intermediary Bank Swift Code</dt>
                  <dd>BOFAUS3NXXX</dd>
                  <dt>Bank address</dt>
                  <dd>
                    GROUND & MEZZANINE FLOOR, SHOP NO -1,2,3 KESAR HOUSE, NEAR
                    SALUNKE VIHAR, PUNE -411048{" "}
                  </dd>
                </>
              )}
            </dl>
          </blockquote>
        </aside>

        <aside>
          <blockquote>
            <h3>ROSS Service Coordination team</h3>
          </blockquote>
          <blockquote>
            <h3>Email</h3>
          </blockquote>
          <blockquote>
            <h3>csa@rossindia.com</h3>
            <h3>service@rossindia.com</h3>
          </blockquote>
          <blockquote>
            <h3>Mobile</h3>
          </blockquote>
          <blockquote>
            <h3>9922433675</h3>
            <h3>9422023803</h3>
          </blockquote>
        </aside>
        <aside>
          {/*
          <img src="/images/5000-satisfied.png" />
          <img src="/images/IBR-CERTIFIED.png" />
          <img src="/images/ISO-9001-2015.png" />*/}
        </aside>
        <button
          onClick={function () {
            nav(`/dashboard/checkin/steps/step4/${quotationId}`);
          }}
          id="continueToOrderFromQuotation"
        >
          Continue to Order
        </button>
      </div>
    </section>
  );
}

export default Step3Ticket;
